import React from 'react';
import { lookupsJson } from '@ourbranch/lookups';
import AutocompleteField from './autocomplete';

const excludedStates = ['AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'];
const stateList = lookupsJson.usStates
  .filter((state) => !excludedStates.includes(state.id))
  .map((state) => ({ ...state, id: state.id, text: state.value }));

const StateField = (props) => {
  const { field, ...restProps } = props;
  return <AutocompleteField stateSelectForm field={{ ...field, options: stateList }} {...restProps} />;
};

export default StateField;
